import { useLocalStorage } from "../infrastructure/hooks/useLocalStorage";

export function useIsMobilapp(): boolean {
  const [isMobilapp] = useLocalStorage<boolean>("isMobilapp", false);

  return isMobilapp;
}

export function getTokenPathParam(pathname: string): string | undefined {
  const pathIncludingTokenRegex =
    /^\/innlogging(?:\/(nb|nn|en))?\/(mobileLogin|mobileSuccess|mobileSuccessWithIDportenLogout)\/([^/]+)/;

  return pathname.match(pathIncludingTokenRegex)?.[3];
}
